import RachelSparkIcon from './RachelSparkIcon';

interface RachelSparkNavIconProps {
  size?: number;
}

const RachelSparkNavIcon = ({ size }: RachelSparkNavIconProps) => (
  <RachelSparkIcon size={size} color="currentColor" />
);

export default RachelSparkNavIcon;
